import { getCurrentGroupId } from '../current';
import { EXTERNAL_GROUP_NAME, SELLER_GROUP_NAME } from '../../../Utils';

export const getGroups = (state = {}) =>
    state.groups || {};

export const getGroupIds = (state = {}) =>
    Object.keys(getGroups(state));

export const getCurrentGroup = (state = {}) =>
    getGroups(state)[getCurrentGroupId(state)];

export const getCurrentGroupType = (state = {}) => {
    const { type } = getCurrentGroup(state) || {};

    return type;
};

const isTabSelected = (type) => (state) => getCurrentGroupType(state) === type;

export const isExternalCollaborationTabSelected = isTabSelected(EXTERNAL_GROUP_NAME);

export const isSellerCollaborationTabSelected = isTabSelected(SELLER_GROUP_NAME);

export const getGroupsIds = (state = {}) =>
    Object.keys(getGroups(state));

export const getGroupsLength = (state = {}) =>
    getGroupsIds(state).length;

export const isGroupsDataExist = (state = {}) =>
    getGroupsLength(state) > 0;

export const getGroupByType = (state = {}, type) =>
    Object.values(getGroups(state))
        .find((group) => group.type === type);

export const getGroupIdByType = (state = {}, type) => {
    const { id } = getGroupByType(state, type) || {};

    return id;
};

export const getGroupByGroupId = (state, groupId) => {
    const groups = getGroups(state);
    return groups[groupId];
};

export const getFileIdsByGroupId = (state = {}, groupId) => {
    const { fileIds } = getGroupByGroupId(state, groupId) || {};

    return fileIds || [];
};

export const getFileIdsByCurrentGroup = (state = {}) => getFileIdsByGroupId(state, getCurrentGroupId(state));

export const isEmpty = (state = {}) =>
    getGroupIds(state).length === 0;

export const isSingle = (state = {}) =>
    getGroupIds(state).length === 1;

export const isGroupExist = (state = {}, groupType) => !!getGroupByType(state, groupType);
